import { render } from "./ConfirmationScreen.vue?vue&type=template&id=15fb759e&scoped=true"
import script from "./ConfirmationScreen.vue?vue&type=script&lang=js"
export * from "./ConfirmationScreen.vue?vue&type=script&lang=js"

import "./installer-page.scss?vue&type=style&index=0&id=15fb759e&lang=scss&scoped=true"
import "./ConfirmationScreen.vue?vue&type=style&index=1&id=15fb759e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15fb759e"]])

export default __exports__